import { getTableColumn, TableColumn } from '@shared/UI';
import { useClientDetailsTable } from './TradeOrderDetailTableProvider';
import { getHeaderClassName } from '@shared/UI/SimpleTable/lib/getHeaderClassName';
import { HeaderCellWithFilter } from '@shared/UI/SimpleTable/components/HeaderCellWithFilter';

export function getTradeOrderDetailTableColumns(): TableColumn<any>[] {
    const { desc, sortFieldName, arrayWithLogos, AssignPositionBody } = useClientDetailsTable();

    const columns: TableColumn<any>[] = [
        getTableColumn({
            title: 'symbol',
            flex: 0.1,
            formatter: (_, row) => {
                return <div className='portfolio__item-name'>{row.symbol ? row.symbol : row.security?.symbol}</div>;
            },
        }),

        getTableColumn({
            dataField: 'totalAmount',
            title: 'Total Amount',
            flex: 0.1,
            firstColumn: true,
            formatter: (_, row) => {
                return `$${row.totalAmount.toFixed(4)}`; // Format percentage with two decimals and add '%' symbol
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Total Amount'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'totalAmount')}`,
        }),

        getTableColumn({
            dataField: 'quantity',
            title: 'Quantity',
            flex: 0.1,
            firstColumn: true,
            formatter: (_, row) => {
                return row.quantity ? `${row.quantity?.toFixed(4)}` : ''; // Format as currency with two decimals
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Quantity'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'quantity')}`,
        }),

        getTableColumn({
            dataField: 'pricePerUnit',
            title: 'Price Per Unit',
            flex: 0.1,
            firstColumn: true,
            formatter: (_, row) => {
                return row?.pricePerUnit ? `$${row.pricePerUnit.toFixed(4)}` : '';
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Price Per Unit'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'pricePerUnit')}`,
        }),

        getTableColumn({
            dataField: 'securityId',
            title: 'Secuirty Id',
            flex: 0.1,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Secuirty Id'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'securityId')}`,
        }),
    ];

    return columns;
}
